import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=232701fd&"
import script from "./CountryItem.vue?vue&type=script&lang=js&"
export * from "./CountryItem.vue?vue&type=script&lang=js&"
import style0 from "./CountryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports